import { LAYOUT_COMPONENT } from '../constant'
import type { AppRoutes } from '../types'

export const permissionRoutes: AppRoutes = [
  /**
   * 首页
   */
  {
    path: '/Home',
    name: 'Home',
    component: () => import('@/views/Main/Home/index.vue')
  },
  /**
   * 登录日志
   */
  {
    path: '/LoginLogs',
    name: 'LoginLogs',
    component: () => import('@/views/Main/LoginLogs/index.vue')
  },
  /**
   * 系统日志
   */
  {
    path: '/SystemLogs',
    name: 'SystemLogs',
    component: () => import('@/views/Main/SystemLogs/index.vue')
  },
  /**
   * 权限管理
   */
  {
    path: '/Permission',
    name: 'Permission',
    component: () => import('@/views/Main/Permission/index.vue')
  },
  /**
   * 部门管理
   */
  {
    path: '/Department',
    name: 'Department',
    component: () => import('@/views/Main/Department/index.vue')
  },
  /**
   * 部门与用户管理
   * @param {string} id 部门Id
   */
  {
    path: '/DepartUser/:id?',
    name: 'DepartUser',
    component: () => import('@/views/Main/DepartUser/index.vue')
  },
  /**
   * 字典管理
   * @param {string} id 字典Id
   */
  {
    path: '/Dictionary/:id?',
    name: 'Dictionary',
    component: () => import('@/views/Main/Dictionary/index.vue')
  },
  /**
   * 菜单管理
   */
  {
    path: '/Menu',
    name: 'Menu',
    component: () => import('@/views/Main/Menu/index.vue')
  },
  /**
   * 角色管理
   */
  {
    path: '/Role',
    name: 'Role',
    component: () => import('@/views/Main/Role/index.vue')
  },
  /**
   * 公职人员
   */
  {
    path: '/PublicServant',
    name: 'PublicServant',
    component: () => import('@/views/Main/PublicServant/index.vue')
  },
  /**
   * 原始档案-项目
   */
  {
    path: '/OriginArchiveXm',
    name: 'OriginArchiveXm',
    component: () => import('@/views/OriginArchive/Xm/index.vue')
  },
  /**
   * 原始档案-征拆户
   */
  {
    path: '/OriginArchiveZch',
    name: 'OriginArchiveZch',
    component: () => import('@/views/OriginArchive/Zch/index.vue')
  },
  /**
   * 政策管理
   */
  {
    path: '/Policy',
    name: 'Policy',
    component: () => import('@/views/Main/Policy/index.vue')
  },
  /**
   * 政策管理-详情
   * @param {string} id 政策Id
   */
  {
    path: '/PolicyDetail/:id',
    name: 'PolicyDetail',
    component: () => import('@/views/Main/Policy/detail.vue'),
    meta: { hiddenInMenu: true, activeMenu: 'Policy' }
  },
  /**
   * 政策管理-搜索
   */
  {
    path: '/PolicySearch',
    name: 'PolicySearch',
    component: () => import('@/views/Main/Policy/Search/index.vue')
  },
  /**
   * 新闻公告
   */
  {
    path: '/News',
    name: 'News',
    component: () => import('@/views/Main/News/index.vue')
  },
  /**
   * 新闻公告-详情
   * @param {string} id 新闻Id
   */
  {
    path: '/NewsDetail/:id',
    name: 'NewsDetail',
    component: () => import('@/views/Main/News/detail.vue'),
    meta: { hiddenInMenu: true, activeMenu: 'News' }
  },
  /**
   * 安置监审审核
   * @param {string} status 审核状态
   */
  {
    path: '/ResettleAuditReview/:status?',
    name: 'ResettleAuditReview',
    component: () => import('@/views/Review/ResettleAudit/index.vue')
  },
  /**
   * 资金监审审核
   * @param {string} status 审核状态
   */
  {
    path: '/FundAuditReview/:status?',
    name: 'FundAuditReview',
    component: () => import('@/views/Review/FundAudit/index.vue')
  },
  /**
   * 被征地农民养老保险审核
   * @param {string} status 审核状态
   */
  {
    path: '/PensionInsuranceReview/:status?',
    name: 'PensionInsuranceReview',
    component: () => import('@/views/Review/PensionInsurance/index.vue')
  },
  /**
   * 房源管理
   */
  {
    path: '/House',
    name: 'House',
    component: () => import('@/views/House/index.vue')
  },
  /**
   * 小区管理
   */
  {
    path: '/Community',
    name: 'Community',
    component: () => import('@/views/Community/index.vue')
  },
  /**
   * 小区-创建
   */
  {
    path: '/CommunityCreate',
    name: 'CommunityCreate',
    component: () => import('@/views/Community/Update/index.vue'),
    meta: { title: '创建小区', hiddenInMenu: true, activeMenu: 'Community' }
  },
  /**
   * 小区-编辑
   * @param {string} id 小区Id
   */
  {
    path: '/CommunityUpdate/:id',
    name: 'CommunityUpdate',
    component: () => import('@/views/Community/Update/index.vue'),
    meta: { title: '编辑小区', hiddenInMenu: true, activeMenu: 'Community' }
  },
  /**
   * 小区-详情
   * @param {string} id 小区Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/CommunityDetail/:id/:idx?',
    name: 'CommunityDetail',
    component: () => import('@/views/Community/Detail/index.vue'),
    meta: { title: '小区详情', hiddenInMenu: true, activeMenu: 'Community' }
  },
  /**
   * 小区-户型管理
   * @param {string} id 小区Id
   */
  {
    path: '/CommunityHouseType/:id',
    name: 'CommunityHouseType',
    component: () => import('@/views/Community/HouseType/index.vue'),
    meta: { title: '户型管理', hiddenInMenu: true, activeMenu: 'Community' }
  },
  /**
   * 小区-房源管理
   * @param {string} id 小区Id
   */
  {
    path: '/CommunityHouse/:id',
    name: 'CommunityHouse',
    component: () => import('@/views/Community/House/index.vue'),
    meta: { title: '房源管理', hiddenInMenu: true, activeMenu: 'Community' }
  },
  /**
   * 房源概况
   */
  {
    path: '/CommunityOverview',
    name: 'CommunityOverview',
    component: () => import('@/views/Community/Overview/index.vue')
  },
  /**
   * 集体土地项目-管理
   */
  {
    path: '/JtProjManage',
    name: 'JtProjManage',
    component: () => import('@/views/JtProj/Manage/index.vue')
  },
  /**
   * 集体土地项目-创建
   */
  {
    path: '/JtProjCreate',
    name: 'JtProjCreate',
    component: () => import('@/views/JtProj/Create/index.vue'),
    meta: { title: '创建集体土地项目', hiddenInMenu: true, activeMenu: 'JtProjManage' }
  },
  /**
   * 集体土地项目-编辑
   * @param {string} id 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/JtProjUpdate/:id/:idx?',
    name: 'JtProjUpdate',
    component: () => import('@/views/JtProj/Update/index.vue'),
    meta: { title: '编辑集体土地项目', layout: LAYOUT_COMPONENT.JT_PROJ, hiddenInMenu: true, back: 'JtProjManage' }
  },
  /**
   * 集体土地项目-详情
   * @param {string} id 项目Id
   * @param {string} idx 菜单idx
   * @param {string} sId 乡镇Id
   */
  {
    path: '/JtProjDetail/:id/:idx?/:sId?',
    name: 'JtProjDetail',
    component: () => import('@/views/JtProj/Detail/index.vue'),
    meta: { title: '集体土地项目详情', layout: LAYOUT_COMPONENT.JT_PROJ, hiddenInMenu: true, back: 'JtProjManage', isDetail: true }
  },
  /**
   * 数据录入-集体土地项目
   */
  {
    path: '/JtProjData',
    name: 'JtProjData',
    component: () => import('@/views/JtProj/Data/index.vue')
  },
  /**
   * 数据录入-集体土地征拆户
   */
  {
    path: '/JtZchData',
    name: 'JtZchData',
    component: () => import('@/views/JtZch/Data/index.vue')
  },
  /**
   * 数据录入-集体土地征拆户-创建
   * @param {string} pId 项目Id
   */
  {
    path: '/JtZchCreate/:pId',
    name: 'JtZchCreate',
    component: () => import('@/views/JtZch/Create/index.vue'),
    meta: { title: '创建集体土地征拆户', hiddenInMenu: true, activeMenu: 'JtZchData' }
  },
  /**
   * 数据录入-集体土地征拆户-编辑
   * @param {string} Id 征拆户Id
   * @param {string} pId 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/JtZchUpdate/:pId/:id/:idx?',
    name: 'JtZchUpdate',
    component: () => import('@/views/JtZch/Update/index.vue'),
    meta: { title: '编辑集体土地征拆户', layout: LAYOUT_COMPONENT.JT_ZCH, hiddenInMenu: true, activeMenu: 'JtZchData', back: 'JtZchData' }
  },
  /**
   * 数据录入-集体土地征拆户-详情
   * @param {string} Id 征拆户Id
   * @param {string} pId 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/JtZchDetail/:pId/:id/:idx?',
    name: 'JtZchDetail',
    component: () => import('@/views/JtZch/Detail/index.vue'),
    meta: { title: '集体土地征拆户详情', layout: LAYOUT_COMPONENT.JT_ZCH, hiddenInMenu: true, activeMenu: 'JtZchData', back: 'JtZchData' }
  },
  /**
   * 集体土地征拆户-审核
   * @param {string} status 审核状态
   */
  {
    path: '/JtZchReview/:status?',
    name: 'JtZchReview',
    component: () => import('@/views/Review/Zch/index.vue')
  },
  /**
   * 数据录入-集体土地项目-信息录入
   * @param {string} id 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/JtProjDataEntry/:id/:idx?',
    name: 'JtProjDataEntry',
    component: () => import('@/views/JtProj/DataEntry/index.vue'),
    meta: { title: '集体土地项目-信息录入', layout: LAYOUT_COMPONENT.JT_PROJ, hiddenInMenu: true, back: 'JtProjData' }
  },
  /**
   * 国有土地项目-管理
   */
  {
    path: '/GyProjManage',
    name: 'GyProjManage',
    component: () => import('@/views/GyProj/Manage/index.vue')
  },
  /**
   * 国有土地项目-创建
   */
  {
    path: '/GyProjCreate',
    name: 'GyProjCreate',
    component: () => import('@/views/GyProj/Create/index.vue'),
    meta: { title: '创建国有土地项目', hiddenInMenu: true, activeMenu: 'GyProjManage' }
  },
  /**
   * 国有土地项目-编辑
   * @param {string} id 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/GyProjUpdate/:id/:idx?',
    name: 'GyProjUpdate',
    component: () => import('@/views/GyProj/Update/index.vue'),
    meta: { title: '编辑国有土地项目', layout: LAYOUT_COMPONENT.GY_PROJ, hiddenInMenu: true, back: 'GyProjManage' }
  },
  /**
   * 国有土地项目-详情
   * @param {string} id 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/GyProjDetail/:id/:idx?',
    name: 'GyProjDetail',
    component: () => import('@/views/GyProj/Detail/index.vue'),
    meta: { title: '国有土地项目详情', layout: LAYOUT_COMPONENT.GY_PROJ, hiddenInMenu: true, back: 'GyProjManage' }
  },
  /**
   * 数据录入-国有土地项目
   */
  {
    path: '/GyProjData',
    name: 'GyProjData',
    component: () => import('@/views/GyProj/Data/index.vue')
  },
  /**
   * 数据录入-国有土地征拆户
   */
  {
    path: '/GyZchData',
    name: 'GyZchData',
    component: () => import('@/views/GyZch/Data/index.vue')
  },
  /**
   * 数据录入-国有土地征拆户-录入
   * @param {string} pId 项目Id
   * @param {string} oId 摸底建档Id
   */
  {
    path: '/GyZchCreate/:pId/:oId',
    name: 'GyZchCreate',
    component: () => import('@/views/GyZch/Create/index.vue'),
    meta: { title: '录入国有土地征拆户', hiddenInMenu: true, activeMenu: 'GyZchData' }
  },
  /**
   * 数据录入-国有土地征拆户-编辑
   * @param {string} pId 项目Id
   * @param {string} id 征拆户
   * @param {string} idx 菜单idx
   */
  {
    path: '/GyZchUpdate/:pId/:id/:idx?',
    name: 'GyZchUpdate',
    component: () => import('@/views/GyZch/Update/index.vue'),
    meta: { title: '录入国有土地征拆户', layout: LAYOUT_COMPONENT.GY_ZCH, hiddenInMenu: true, back: 'GyZchData' }
  },
  /**
   * 数据录入-国有土地征拆户-详情
   * @param {string} Id 征拆户Id
   * @param {string} pId 项目Id
   * @param {string} idx 菜单idx
   */
  {
    path: '/GyZchDetail/:pId/:id/:idx?',
    name: 'GyZchDetail',
    component: () => import('@/views/GyZch/Detail/index.vue'),
    meta: { title: '国有土地征拆户详情', layout: LAYOUT_COMPONENT.GY_ZCH, hiddenInMenu: true, activeMenu: 'GyZchData', back: 'GyZchData' }
  },
  /**
   * 国有土地征拆户-审核
   * @param {string} status 审核状态
   */
  {
    path: '/GyZchReview/:status?',
    name: 'GyZchReview',
    component: () => import('@/views/Review/Zch/index.vue')
  },
  /**
   * 异常数据告警
   * @param {string} status 处理状态
   */
  {
    path: '/DataAlarm/:status?',
    name: 'DataAlarm',
    component: () => import('@/views/DataAlarm/index.vue')
  },
  /**
   * 数据检索
   */
  {
    path: '/GlobalSearch/:keyword?',
    name: 'GlobalSearch',
    component: () => import('@/views/GlobalSearch/index.vue')
  },
  /**
   * 业务一张图
   */
  {
    path: '/Ywyzt',
    name: 'Ywyzt',
    component: () => import('@/views/Ywyzt/index.vue')
  },
  /**
   * 数据总览
   */
  {
    path: '/DataOverview',
    name: 'DataOverview',
    component: () => import('@/views/DataOverview/index.vue')
  },
  /**
   * 专项统计
   */
  {
    path: '/SpecialStatistics',
    name: 'SpecialStatistics',
    component: () => import('@/views/SpecialStatistics/index.vue')
  },
  /**
   * 专项统计(新)
   */
  {
    path: '/SpecialStatisticsNew',
    name: 'SpecialStatisticsNew',
    component: () => import('@/views/SpecialStatisticsNew/index.vue')
  },
  /**
   * 房票放款
   */
  {
    path: '/TicketLoan',
    name: 'TicketLoan',
    component: () => import('@/views/TicketLoan/index.vue')
  },
  /**
   * 集体土地项目总览
   */
  {
    path: '/JtProjAna',
    name: 'JtProjAna',
    component: () => import('@/views/Ana/JtProj/index.vue')
  },
  /**
   * 国有土地项目总览
   */
  {
    path: '/GyProjAna',
    name: 'GyProjAna',
    component: () => import('@/views/Ana/GyProj/index.vue')
  },
  /**
   * 房票补差导入
   */
  {
    path: '/TickDiffImp',
    name: 'TickDiffImp',
    component: () => import('@/views/TickDiff/Imp/index.vue')
  },
  /**
   * 房票补差明细
   */
  {
    path: '/TickDiff',
    name: 'TickDiff',
    component: () => import('@/views/TickDiff/index.vue')
  },
  /**
   * 房票放款导入
   */
  {
    path: '/TicketLoanImp',
    name: 'TicketLoanImp',
    component: () => import('@/views/TicketLoan/Imp/index.vue'),
    meta: { title: '房票放款导入', hiddenInMenu: true, activeMenu: 'TicketLoanImpRecord' }
  },
  /**
   * 房票放款导入记录
   */
  {
    path: '/TicketLoanImpRecord',
    name: 'TicketLoanImpRecord',
    component: () => import('@/views/TicketLoan/ImpRecord/index.vue')
  },
  /**
   * 房票放款明细
   */
  {
    path: '/TicketLoan',
    name: 'TicketLoan',
    component: () => import('@/views/TicketLoan/index.vue')
  },
  /**
   * 房票放款明细
   */
  {
    path: '/TicketErr',
    name: 'TicketErr',
    component: () => import('@/views/TicketErr/index.vue')
  },
  /**
   * 房票明细模板
   */
  {
    path: '/TicketTpl',
    name: 'TicketTpl',
    component: () => import('@/views/TicketTpl/index.vue')
  },
  /**
   * 房票计划放款
   */
  {
    path: '/TicketPlan',
    name: 'TicketPlan',
    component: () => import('@/views/TicketPlan/index.vue')
  },
  /**
   * 房票清单
   */
  {
    path: '/TicketList',
    name: 'TicketList',
    component: () => import('@/views/TicketList/index.vue')
  }
]
